var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagonalArrowGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53538 0.630859C8.7564 0.630859 8.96836 0.718657 9.12464 0.874937C9.28092 1.03122 9.36872 1.24318 9.36872 1.46419V7.35753C9.36872 7.57854 9.28092 7.7905 9.12464 7.94678C8.96836 8.10306 8.7564 8.19086 8.53538 8.19086C8.31437 8.19086 8.10241 8.10306 7.94613 7.94678C7.78985 7.7905 7.70205 7.57854 7.70205 7.35753V3.47669L2.05288 9.12503C1.89572 9.27682 1.68521 9.36082 1.46672 9.35892C1.24822 9.35702 1.03921 9.26938 0.884703 9.11487C0.730196 8.96037 0.642555 8.75136 0.640657 8.53286C0.638758 8.31436 0.722753 8.10386 0.874552 7.94669L6.52288 2.29753H2.64288C2.42187 2.29753 2.20991 2.20973 2.05363 2.05345C1.89735 1.89717 1.80955 1.68521 1.80955 1.46419C1.80955 1.24318 1.89735 1.03122 2.05363 0.874937C2.20991 0.718657 2.42187 0.630859 2.64288 0.630859H8.53538Z",
    fill: "#0A795E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalArrowGreen);
export default __webpack_public_path__ + "static/media/diagonalArrowGreen.1c4a2fb1bf9aaa397a43a02a003d1445.svg";
export { ForwardRef as ReactComponent };